import { UseFormRegister } from "react-hook-form";

import { PART_TAG_LINE_MODES, PartTagFormValues } from "../../utils/partTagFields";

interface PartTagLineModeInputProps {
  register: UseFormRegister<PartTagFormValues>;
}

// The line under the header carries one thing: make/model/category or the stock number.
export default function PartTagLineModeInput({ register }: PartTagLineModeInputProps) {
  return (
    <div className="rounded-md border border-gray-200 bg-white p-3">
      <h2 className="text-sm font-semibold text-gray-900">Line under the header</h2>
      <p className="text-xs text-gray-500 mt-0.5">Choose one. Make, model and category is the default.</p>

      <div className="mt-3 grid grid-cols-1 sm:grid-cols-3 gap-x-4 gap-y-2">
        {PART_TAG_LINE_MODES.map((mode) => (
          <label key={mode.value} className="flex items-start gap-2 cursor-pointer">
            <input
              type="radio"
              value={mode.value}
              {...register("lineMode")}
              className="mt-0.5 h-4 w-4 shrink-0 border-gray-300 text-primary-600 focus:ring-primary-500"
            />
            <span className="min-w-0">
              <span className="block text-sm font-medium text-gray-700">{mode.label}</span>
              <span className="block text-xs text-gray-500">{mode.hint}</span>
            </span>
          </label>
        ))}
      </div>
    </div>
  );
}
